import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { changeShowNavigationBar } from "../store/components";

const Testpdf = () => {
  const targetedDiv = useRef();
  const secondDiv = useRef();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(changeShowNavigationBar({ value: false }));
    // let { scrollHeight, clientHeight } = targetedDiv.current;
    let { scrollHeight, clientHeight } = secondDiv.current;

    console.log("This is the scroll for secondDiv heigth", scrollHeight);
    console.log("This is the client for secondDiv heigth", clientHeight);
    console.log(
      "This is the scroll for targeted heigth",
      targetedDiv.current.scrollHeight
    );
    console.log(
      "This is the client for targeted heigth",
      targetedDiv.current.clientHeight
    );
  });

  return (
    <div
      ref={targetedDiv}
      style={{ minHeight: "100px", width: "100px", backgroundColor: "green" }}
    >
      <div
        ref={secondDiv}
        style={{ width: "100%", minHeight: "10px", backgroundColor: "red" }}
      >
        <div
          style={{
            width: "100%",
            minHeight: "25px",
            backgroundColor: "yellow",
          }}
        ></div>
      </div>
      <div style={{ width: "100%", minHeight: "10px", backgroundColor: "red" }}>
        <div
          style={{
            width: "100%",
            minHeight: "25px",
            backgroundColor: "yellow",
          }}
        ></div>
      </div>
      <div style={{ width: "100%", minHeight: "10px", backgroundColor: "red" }}>
        <div
          style={{
            width: "100%",
            minHeight: "25px",
            backgroundColor: "yellow",
          }}
        ></div>
      </div>
      <div style={{ width: "100%", minHeight: "10px", backgroundColor: "red" }}>
        <div
          style={{
            width: "100%",
            minHeight: "26px",
            backgroundColor: "yellow",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Testpdf;
